import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, withCtx as _withCtx, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-daefeb5c")
const _hoisted_1 = { class: "_loadPrompt" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "_header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "_headerText" }, " ... ")
], -1)
const _hoisted_3 = { class: "centralSpinner" }
const _hoisted_4 = { class: "_header" }
const _hoisted_5 = { class: "_headerBack" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", { class: "_headerText" }, " Denied ", -1)
const _hoisted_7 = { class: "_main" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h2", null, "Denied", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "_a" }, null, -1)
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "_b" }, null, -1)
const _hoisted_13 = { class: "_giveMeSpace" }
const _hoisted_14 = { class: "_header" }
const _hoisted_15 = { class: "_headerBack" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h3", { class: "_headerText" }, " Joining lobby ", -1)
const _hoisted_17 = { class: "_main" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "_a" }, null, -1)
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "_b" }, null, -1)
const _hoisted_22 = {
  key: 0,
  class: "_backgroundBlur"
}
const _hoisted_23 = {
  key: 1,
  class: "_backgroundNoClick"
}
const _hoisted_24 = { class: "_header" }
const _hoisted_25 = { class: "_headerBack" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("h3", { class: "_headerText" }, " Lobby ", -1)
const _hoisted_27 = {
  key: 4,
  class: "lobby"
}
const _hoisted_28 = { class: "gameDetails" }
const _hoisted_29 = {
  key: 0,
  class: "_backgroundBlur _field"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "latest" }, "Our latest", -1)
const _hoisted_31 = { class: "title" }
const _hoisted_32 = { class: "titleWrapper" }
const _hoisted_33 = { class: "meta" }
const _hoisted_34 = {
  key: 0,
  class: "rating"
}
const _hoisted_35 = {
  key: 0,
  class: "count"
}
const _hoisted_36 = {
  key: 1,
  class: "rating"
}
const _hoisted_37 = { class: "features" }
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { key: 1 }
const _hoisted_40 = {
  key: 0,
  class: "attributions"
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("h4", null, "Attributions", -1)
const _hoisted_42 = { class: "index num" }
const _hoisted_43 = { class: "index" }
const _hoisted_44 = ["href"]
const _hoisted_45 = {
  key: 0,
  id: "lobbyWrapper"
}
const _hoisted_46 = {
  key: 0,
  class: "_backgroundBlur _field"
}
const _hoisted_47 = {
  key: 0,
  class: "codeWrapper"
}
const _hoisted_48 = { class: "code" }
const _hoisted_49 = { key: 0 }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "codeSpacer" }, null, -1)
const _hoisted_51 = {
  key: 1,
  class: "codeWrapper"
}
const _hoisted_52 = {
  key: 0,
  class: "_backgroundBlur _field"
}
const _hoisted_53 = {
  key: 2,
  class: "code"
}
const _hoisted_54 = { key: 0 }
const _hoisted_55 = { key: 1 }
const _hoisted_56 = {
  key: 3,
  class: "code"
}
const _hoisted_57 = /*#__PURE__*/_createElementVNode("h2", null, "Starting", -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("h4", null, "Click timer to stop", -1)
const _hoisted_59 = [
  _hoisted_57,
  _hoisted_58
]
const _hoisted_60 = /*#__PURE__*/_createElementVNode("div", { class: "codeSpacer" }, null, -1)
const _hoisted_61 = {
  key: 3,
  class: "progressWrapper"
}
const _hoisted_62 = /*#__PURE__*/_createElementVNode("h4", null, "Game finished", -1)
const _hoisted_63 = {
  key: 4,
  class: "progressWrapper"
}
const _hoisted_64 = /*#__PURE__*/_createElementVNode("h4", null, "Game stopped", -1)
const _hoisted_65 = {
  key: 5,
  class: "progressWrapper"
}
const _hoisted_66 = { id: "lobby" }
const _hoisted_67 = { class: "_header" }
const _hoisted_68 = { class: "_headerBack" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("h3", { class: "_headerText" }, " No lobby found ", -1)
const _hoisted_70 = { class: "_main" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("h4", null, "hmmm...", -1)
const _hoisted_72 = /*#__PURE__*/_createElementVNode("p", null, " It appears no lobby matches the credentials supplied. ", -1)
const _hoisted_73 = { class: "_giveMeSpace" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadSpinner = _resolveComponent("LoadSpinner")!
  const _component_MovingIcon = _resolveComponent("MovingIcon")!
  const _component_IconButton = _resolveComponent("IconButton")!
  const _component_TutorialPopup = _resolveComponent("TutorialPopup")!
  const _component_LazyImage = _resolveComponent("LazyImage")!
  const _component_ToggleWindow = _resolveComponent("ToggleWindow")!
  const _component_Countdown = _resolveComponent("Countdown")!
  const _component_LobbyWindow = _resolveComponent("LobbyWindow")!

  return (_ctx.lobbyLoading)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_LoadSpinner, { text: "Loading lobby" })
        ]),
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_MovingIcon, {
            name: "loader_spinner",
            autoplay: true,
            loop: true
          })
        ])
      ], 64))
    : (!_ctx.lobbyPermission || _ctx.lobbyPermission.banned == true)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_IconButton, {
                icon: "back",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({path:'/app'}))),
                white: true
              })
            ]),
            _hoisted_6
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _hoisted_9,
            (!_ctx.$store.state.GameView.lobby)
              ? (_openBlock(), _createElementBlock("p", _hoisted_10, " The lobby was deleted. We delete all empty lobbies every 30 minutes once they are older than an hour. "))
              : (_openBlock(), _createElementBlock("p", _hoisted_11, " Sorry, you do not have permission to access this lobby. ")),
            _hoisted_12,
            _createElementVNode("p", _hoisted_13, [
              _createVNode(_component_IconButton, {
                text: "Join a game",
                icon: "back",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({path:'/app/join'})))
              })
            ])
          ])
        ], 64))
      : (_ctx.lobby?.meta && _ctx.lobbyPermission.banned == false && _ctx.lobbyPermission.joined == false)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_IconButton, {
                  icon: "back",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push({path:'/app'}))),
                  white: true
                })
              ]),
              _hoisted_16
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("h3", null, "Joining lobby " + _toDisplayString(_ctx.lobby.meta.code), 1),
              _hoisted_18,
              (_ctx.$store.state.Auth.user.name)
                ? (_openBlock(), _createElementBlock("p", _hoisted_19, " Please wait while we connect you to the lobby. "))
                : (_openBlock(), _createElementBlock("p", _hoisted_20, " Redirecting to lobby joiner. ")),
              _hoisted_21,
              _createVNode(_component_MovingIcon, {
                name: "loader_spinner",
                autoplay: true,
                loop: true
              })
            ])
          ], 64))
        : (_ctx.$store.state.GameView.lobby?.meta?.code && _ctx.$store.state.GameView.lobby?.meta?.gameId)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              (_ctx.tutorialPhase==0 && !_ctx.$store.state.GameView?.lobby?.playthrough?.started)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22))
                : _createCommentVNode("", true),
              (_ctx.tutorialPhase>0 && _ctx.tutorialPhase<8 && !_ctx.$store.state.GameView?.lobby?.playthrough?.started)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23))
                : _createCommentVNode("", true),
              (_ctx.tutorialPhase==0 && !_ctx.$store.state.GameView?.lobby?.playthrough?.started)
                ? (_openBlock(), _createBlock(_component_TutorialPopup, {
                    key: 2,
                    class: "fixed centre",
                    header: "Tutorial - step 1",
                    subheader: "Introduction",
                    body: "Over the next few minutes you'll learn the basics on how to play. So let's get started!",
                    stage: _ctx.tutorialPhase,
                    max: _ctx.tutorialLength,
                    onForward: _cache[3] || (_cache[3] = ($event: any) => (_ctx.tutorialPhase++)),
                    onBack: _cache[4] || (_cache[4] = ($event: any) => (_ctx.tutorialPhase--))
                  }, null, 8, ["stage", "max"]))
                : _createCommentVNode("", true),
              (_ctx.tutorialPhase==1 && !_ctx.$store.state.GameView?.lobby?.playthrough?.started)
                ? (_openBlock(), _createBlock(_component_TutorialPopup, {
                    key: 3,
                    class: "fixed bottom",
                    header: "The lobby screen",
                    body: "This is displayed when a game is hosted or joined. It contains two parts:",
                    stage: _ctx.tutorialPhase,
                    max: _ctx.tutorialLength,
                    onForward: _cache[5] || (_cache[5] = ($event: any) => (_ctx.tutorialPhase++)),
                    onBack: _cache[6] || (_cache[6] = ($event: any) => (_ctx.tutorialPhase--))
                  }, null, 8, ["stage", "max"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(_component_IconButton, {
                    icon: "back",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$router.push({path:'/app'}))),
                    white: true
                  })
                ]),
                _hoisted_26
              ]),
              (_ctx.$store.state.GameView.game)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      (_ctx.tutorialPhase>2 && _ctx.tutorialPhase<8)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_29))
                        : _createCommentVNode("", true),
                      (_ctx.tutorialPhase==2 && !_ctx.$store.state.GameView?.lobby?.playthrough?.started)
                        ? (_openBlock(), _createBlock(_component_TutorialPopup, {
                            key: 1,
                            header: "The game's details",
                            stage: _ctx.tutorialPhase,
                            max: _ctx.tutorialLength,
                            onForward: _cache[8] || (_cache[8] = ($event: any) => (_ctx.tutorialPhase++)),
                            onBack: _cache[9] || (_cache[9] = ($event: any) => (_ctx.tutorialPhase--))
                          }, null, 8, ["stage", "max"]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_LazyImage, {
                        class: "displayImage _imageFade",
                        src: _ctx.$store.state.GameView.game?.image
                      }, {
                        default: _withCtx(() => [
                          _hoisted_30
                        ]),
                        _: 1
                      }, 8, ["src"]),
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("h1", null, _toDisplayString(_ctx.$store.state.GameView.game.title), 1)
                        ]),
                        _createElementVNode("p", null, [
                          _createElementVNode("div", {
                            class: _normalizeClass({difficulty:true,[`_${_ctx.difficulties[_ctx.$store.state.GameView.game.difficulty]}`]:true})
                          }, null, 2),
                          _createTextVNode(" - " + _toDisplayString(_ctx.$store.state.GameView.game.minutes) + " minutes ", 1)
                        ]),
                        _createElementVNode("div", _hoisted_33, [
                          (_ctx.$store.state.GameView.game.rating.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                _createVNode(_component_MovingIcon, {
                                  name: Math.min(Math.max(0,_ctx.$store.state.GameView.game.rating.value),1)>0?'star_filled':'star',
                                  hex: Math.min(Math.max(0,_ctx.$store.state.GameView.game.rating.value),1)>0?'#000000':'#a0a0a0',
                                  type: "svg"
                                }, null, 8, ["name", "hex"]),
                                _createVNode(_component_MovingIcon, {
                                  name: Math.min(Math.max(0,_ctx.$store.state.GameView.game.rating.value-1),1)>0?'star_filled':'star',
                                  hex: Math.min(Math.max(0,_ctx.$store.state.GameView.game.rating.value-1),1)>0?'#000000':'#a0a0a0',
                                  type: "svg"
                                }, null, 8, ["name", "hex"]),
                                _createVNode(_component_MovingIcon, {
                                  name: Math.min(Math.max(0,_ctx.$store.state.GameView.game.rating.value-2),1)>0?'star_filled':'star',
                                  hex: Math.min(Math.max(0,_ctx.$store.state.GameView.game.rating.value-2),1)>0?'#000000':'#a0a0a0',
                                  type: "svg"
                                }, null, 8, ["name", "hex"]),
                                _createVNode(_component_MovingIcon, {
                                  name: Math.min(Math.max(0,_ctx.$store.state.GameView.game.rating.value-3),1)>0?'star_filled':'star',
                                  hex: Math.min(Math.max(0,_ctx.$store.state.GameView.game.rating.value-3),1)>0?'#000000':'#a0a0a0',
                                  type: "svg"
                                }, null, 8, ["name", "hex"]),
                                _createVNode(_component_MovingIcon, {
                                  name: Math.min(Math.max(0,_ctx.$store.state.GameView.game.rating.value-4),1)>0?'star_filled':'star',
                                  hex: Math.min(Math.max(0,_ctx.$store.state.GameView.game.rating.value-4),1)>0?'#000000':'#a0a0a0',
                                  type: "svg"
                                }, null, 8, ["name", "hex"]),
                                (_ctx.$store.state.GameView.game.rating.number)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, " (" + _toDisplayString(_ctx.$store.state.GameView.game.rating.number) + ") ", 1))
                                  : _createCommentVNode("", true)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                _createVNode(_component_MovingIcon, {
                                  name: "loader_spinner",
                                  autoplay: true,
                                  loop: true
                                })
                              ])),
                          _createElementVNode("div", _hoisted_37, [
                            (_ctx.$store.state.GameView.game?.features?.maps)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                  _createVNode(_component_MovingIcon, {
                                    name: "maps",
                                    type: "svg"
                                  })
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.$store.state.GameView.game?.features?.web)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                  _createVNode(_component_MovingIcon, {
                                    name: "web",
                                    type: "svg"
                                  })
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createVNode(_component_ToggleWindow, {
                          default: true,
                          text: "Description"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$store.state.GameView.game.description), 1)
                          ]),
                          _: 1
                        }),
                        (_ctx.$store.state.GameView.game.attributions && _ctx.$store.state.GameView.game.attributions.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                              _hoisted_41,
                              _createElementVNode("table", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.state.GameView.game.attributions, (a, index) => {
                                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                    (a.resource)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _createElementVNode("td", _hoisted_42, _toDisplayString(index) + ".", 1),
                                          _createElementVNode("td", _hoisted_43, _toDisplayString(a.resource) + ": " + _toDisplayString(a.author) + ". ", 1),
                                          _createElementVNode("td", null, [
                                            _createElementVNode("a", {
                                              target: "_blank",
                                              href: a.license
                                            }, "License", 8, _hoisted_44)
                                          ])
                                        ], 64))
                                      : _createCommentVNode("", true)
                                  ]))
                                }), 128))
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    (_ctx.$store.state.GameView.lobby && _ctx.$store.state.GameView.lobby.playthrough)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                          (_ctx.tutorialPhase==2)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_46))
                            : _createCommentVNode("", true),
                          (_ctx.tutorialPhase==3 && !_ctx.$store.state.GameView?.lobby?.playthrough?.started)
                            ? (_openBlock(), _createBlock(_component_TutorialPopup, {
                                key: 1,
                                header: "The lobby",
                                body: "This also contains some important elements!",
                                stage: _ctx.tutorialPhase,
                                max: _ctx.tutorialLength,
                                onForward: _cache[10] || (_cache[10] = ($event: any) => (_ctx.tutorialPhase++)),
                                onBack: _cache[11] || (_cache[11] = ($event: any) => (_ctx.tutorialPhase--))
                              }, null, 8, ["stage", "max"]))
                            : _createCommentVNode("", true),
                          (!_ctx.$store.state.GameView?.lobby?.playthrough?.finished && !_ctx.$store.state.GameView?.lobby?.playthrough?.stopped)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                (_ctx.$store.state.GameView?.lobby?.playthrough?.started > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                      (_ctx.tutorialPhase>=0)
                                        ? (_openBlock(), _createBlock(_component_TutorialPopup, {
                                            key: 0,
                                            class: "right",
                                            header: "The game has started",
                                            body: "Click the enter button to rejoin the game.",
                                            stage: 0,
                                            max: 0,
                                            onForward: _cache[12] || (_cache[12] = ($event: any) => {_ctx.tutorialPhase++;}),
                                            onBack: _cache[13] || (_cache[13] = ($event: any) => (_ctx.tutorialPhase--))
                                          }))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("div", _hoisted_48, [
                                        _createElementVNode("h2", null, _toDisplayString(_ctx.$route.params?.code), 1),
                                        (_ctx.$store.state.GameView.lobby.players)
                                          ? (_openBlock(), _createElementBlock("h4", _hoisted_49, "Players in game: " + _toDisplayString(Object.entries(_ctx.$store.state.GameView.lobby.players).length), 1))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _hoisted_50,
                                      _createElementVNode("div", null, [
                                        _createVNode(_component_IconButton, {
                                          text: "Enter",
                                          colored: true,
                                          onClick: _ctx.enterPlaythrough
                                        }, null, 8, ["onClick"])
                                      ])
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_51, [
                                      (_ctx.tutorialPhase>5 && _ctx.tutorialPhase<8)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_52))
                                        : _createCommentVNode("", true),
                                      (_ctx.tutorialPhase==4 && !_ctx.$store.state.GameView?.lobby?.playthrough?.started)
                                        ? (_openBlock(), _createBlock(_component_TutorialPopup, {
                                            key: 1,
                                            class: "left",
                                            header: "The lobby code",
                                            body: "This is what you share to invite others to your game.",
                                            stage: _ctx.tutorialPhase,
                                            max: _ctx.tutorialLength,
                                            onForward: _cache[14] || (_cache[14] = ($event: any) => (_ctx.tutorialPhase++)),
                                            onBack: _cache[15] || (_cache[15] = ($event: any) => (_ctx.tutorialPhase--))
                                          }, null, 8, ["stage", "max"]))
                                        : _createCommentVNode("", true),
                                      (!_ctx.$store.state.GameView.lobby.playthrough.countdownStarted)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                            _createElementVNode("h2", null, _toDisplayString(_ctx.$route.params?.code), 1),
                                            (_ctx.$store.state.GameView.lobby.players)
                                              ? (_openBlock(), _createElementBlock("h4", _hoisted_54, "Players in lobby: " + _toDisplayString(Object.entries(_ctx.$store.state.GameView.lobby.players).length), 1))
                                              : (_openBlock(), _createElementBlock("h4", _hoisted_55, "Players in lobby: 1"))
                                          ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_56, _hoisted_59)),
                                      _hoisted_60,
                                      ((_ctx.$store.state.Auth.user.id == _ctx.$store.state.GameView.lobby.meta.host) || _ctx.$store.state.GameView.lobby.playthrough.countdownStarted)
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 4,
                                            class: _normalizeClass({counterWrapper:true,_counting:_ctx.$store.state.GameView.lobby.playthrough.countdownStarted})
                                          }, [
                                            (_ctx.tutorialPhase==5 && !_ctx.$store.state.GameView?.lobby?.playthrough?.started)
                                              ? (_openBlock(), _createBlock(_component_TutorialPopup, {
                                                  key: 0,
                                                  class: "right",
                                                  header: "The play button",
                                                  body: "You click this to begin a countdown to start a game.",
                                                  stage: _ctx.tutorialPhase,
                                                  max: _ctx.tutorialLength,
                                                  onForward: _cache[16] || (_cache[16] = ($event: any) => (_ctx.tutorialPhase++)),
                                                  onBack: _cache[17] || (_cache[17] = ($event: any) => (_ctx.tutorialPhase--))
                                                }, null, 8, ["stage", "max"]))
                                              : _createCommentVNode("", true),
                                            (_ctx.tutorialPhase==8 && _ctx.$store.state.GameView.lobby.playthrough.countdownStarted && !_ctx.$store.state.GameView?.lobby?.playthrough?.started)
                                              ? (_openBlock(), _createBlock(_component_TutorialPopup, {
                                                  key: 1,
                                                  class: "right",
                                                  header: "You can stop it too!",
                                                  body: "Click the countdown to stop it. Anyone in the lobby can do this!",
                                                  stage: _ctx.tutorialPhase,
                                                  max: _ctx.tutorialLength,
                                                  onForward: _cache[18] || (_cache[18] = ($event: any) => {_ctx.tutorialPhase++; _ctx.addFakie()}),
                                                  onBack: _cache[19] || (_cache[19] = ($event: any) => (_ctx.tutorialPhase--))
                                                }, null, 8, ["stage", "max"]))
                                              : (_ctx.tutorialPhase==8 && !_ctx.$store.state.GameView?.lobby?.playthrough?.started)
                                                ? (_openBlock(), _createBlock(_component_TutorialPopup, {
                                                    key: 2,
                                                    class: "right",
                                                    header: "Let's play!",
                                                    body: "Click the play button to start the countdown. Only the host can do this!",
                                                    stage: _ctx.tutorialPhase,
                                                    max: _ctx.tutorialLength,
                                                    onForward: _cache[20] || (_cache[20] = ($event: any) => {_ctx.tutorialPhase++; _ctx.addFakie()}),
                                                    onBack: _cache[21] || (_cache[21] = ($event: any) => (_ctx.tutorialPhase--))
                                                  }, null, 8, ["stage", "max"]))
                                                : _createCommentVNode("", true),
                                            _createVNode(_component_Countdown, {
                                              duration: 10,
                                              startTime: _ctx.$store.state.GameView.lobby.playthrough.countdownStarted,
                                              sound: true,
                                              onClick: _ctx.startCountdown,
                                              onComplete: _ctx.triggerPlaythroughStart,
                                              onReadonly: _cache[22] || (_cache[22] = ($event: any) => ((_ctx.$store.state.Auth.user.id != _ctx.$store.state.GameView.lobby.meta.host) && !_ctx.$store.state.GameView.lobby.playthrough.countdownStarted))
                                            }, null, 8, ["startTime", "onClick", "onComplete"])
                                          ], 2))
                                        : _createCommentVNode("", true)
                                    ]))
                              ], 64))
                            : _createCommentVNode("", true),
                          (_ctx.$store.state.GameView.lobby.playthrough.finished)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                                _hoisted_62,
                                _createElementVNode("p", null, "Finished at: " + _toDisplayString(_ctx.finishedTime), 1),
                                _createElementVNode("p", null, "Escaped in: " + _toDisplayString(_ctx.timeLeft((_ctx.$store.state.GameView.lobby.playthrough.finished - _ctx.$store.state.GameView.lobby.playthrough.started - _ctx.$store.state.GameView.lobby.playthrough.pauseSum)/1000)), 1)
                              ]))
                            : (_ctx.$store.state.GameView?.lobby?.playthrough?.stopped)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                                  _hoisted_64,
                                  _createElementVNode("p", null, "Stopped at: " + _toDisplayString(_ctx.stoppedTime), 1)
                                ]))
                              : (_ctx.$store.state.GameView?.lobby?.playthrough?.started)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                                    _createElementVNode("p", null, "Started at: " + _toDisplayString(_ctx.startedTime), 1)
                                  ]))
                                : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_66, [
                            (_ctx.$store.state.GameView.lobby)
                              ? (_openBlock(), _createBlock(_component_LobbyWindow, { key: 0 }))
                              : _createCommentVNode("", true),
                            (_ctx.tutorialPhase==6)
                              ? (_openBlock(), _createBlock(_component_TutorialPopup, {
                                  key: 1,
                                  class: "left middleLong",
                                  header: "The player list",
                                  body: "Here you can see who has joined the game. Hosts can click players to kick or promote them.",
                                  stage: _ctx.tutorialPhase,
                                  max: _ctx.tutorialLength,
                                  onForward: _cache[23] || (_cache[23] = ($event: any) => {_ctx.tutorialPhase++; _ctx.addFakie()}),
                                  onBack: _cache[24] || (_cache[24] = ($event: any) => (_ctx.tutorialPhase--))
                                }, null, 8, ["stage", "max"]))
                              : _createCommentVNode("", true),
                            (_ctx.tutorialPhase==7)
                              ? (_openBlock(), _createBlock(_component_TutorialPopup, {
                                  key: 2,
                                  class: "left middleLong",
                                  header: "Someone joined!",
                                  body: "This is how it looks when someone joins your lobby",
                                  stage: _ctx.tutorialPhase,
                                  max: _ctx.tutorialLength,
                                  onForward: _cache[25] || (_cache[25] = ($event: any) => {_ctx.tutorialPhase++; _ctx.addFakie()}),
                                  onBack: _cache[26] || (_cache[26] = ($event: any) => (_ctx.tutorialPhase--))
                                }, null, 8, ["stage", "max"]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
              _createElementVNode("div", _hoisted_67, [
                _createElementVNode("div", _hoisted_68, [
                  _createVNode(_component_IconButton, {
                    icon: "back",
                    onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.$router.push({path:'/app'}))),
                    white: true
                  })
                ]),
                _hoisted_69
              ]),
              _createElementVNode("div", _hoisted_70, [
                _hoisted_71,
                _hoisted_72,
                _createElementVNode("p", _hoisted_73, [
                  _createVNode(_component_IconButton, {
                    text: "Join a game",
                    icon: "back",
                    onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.$router.push({path:'/app/join'})))
                  })
                ])
              ])
            ], 64))
}